import styled from 'styled-components';

export const StyledVehicleFilterTags = styled.div`
    padding-top: 2rem;
    display: flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.tokens.BaseSpace20};
    align-items: center;
`;
